/**
 * @generated SignedSource<<13b7012bdbbbaff2c9730edadba210ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesPeriod = {
  endAt: any;
  startAt: any;
};
export type SalesAssociatePerformanceScreenQuery$variables = {
  storeId: string;
  salesAssociateId: string;
  period: SalesPeriod;
};
export type SalesAssociatePerformanceScreenQuery$data = {
  readonly salesAssociate: {
    readonly name: string | null;
    readonly __typename: "SalesAssociate";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly viewer: {
    readonly configuration: {
      readonly viewOthersSalesAssociatesPerformance: boolean;
    };
    readonly salesAssociate: {
      readonly id: string;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"IndicatorCards_indicators">;
};
export type SalesAssociatePerformanceScreenQuery = {
  variables: SalesAssociatePerformanceScreenQuery$variables;
  response: SalesAssociatePerformanceScreenQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "period"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesAssociateId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "salesAssociateId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UserConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewOthersSalesAssociatesPerformance",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesAssociate",
  "kind": "LinkedField",
  "name": "salesAssociate",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "period",
  "variableName": "period"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageItemAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageItemsPerSale",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageSalesAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesAssociatePerformanceScreenQuery",
    "selections": [
      {
        "alias": "salesAssociate",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "type": "SalesAssociate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VtexUser",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndicatorCards_indicators"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SalesAssociatePerformanceScreenQuery",
    "selections": [
      {
        "alias": "salesAssociate",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v9/*: any*/),
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "eq",
                            "variableName": "storeId"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "storeId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "SalesIndicators",
                "kind": "LinkedField",
                "name": "salesIndicators",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salesAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salesQuantity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalItemsSold",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "SalesAssociate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VtexUser",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "store",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "storeId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v9/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "SalesIndicators",
                "kind": "LinkedField",
                "name": "salesIndicators",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Store",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d437ea629ca7783b95c2e733f304c1a",
    "id": null,
    "metadata": {},
    "name": "SalesAssociatePerformanceScreenQuery",
    "operationKind": "query",
    "text": "query SalesAssociatePerformanceScreenQuery(\n  $storeId: ID!\n  $salesAssociateId: ID!\n  $period: SalesPeriod!\n) {\n  salesAssociate: node(id: $salesAssociateId) {\n    __typename\n    ... on SalesAssociate {\n      name\n      __typename\n    }\n    id\n  }\n  viewer {\n    configuration {\n      viewOthersSalesAssociatesPerformance\n    }\n    salesAssociate {\n      id\n    }\n  }\n  ...IndicatorCards_indicators\n}\n\nfragment IndicatorCards_indicators on Query {\n  viewer {\n    brand {\n      currencyCode\n      id\n    }\n  }\n  store: node(id: $storeId) {\n    __typename\n    ... on Store {\n      salesIndicators(where: {period: $period}) {\n        averageItemAmount\n        averageItemsPerSale\n        averageSalesAmount\n      }\n      __typename\n    }\n    id\n  }\n  salesAssociate: node(id: $salesAssociateId) {\n    __typename\n    ... on SalesAssociate {\n      salesIndicators(where: {storeId: {eq: $storeId}, period: $period}) {\n        salesAmount\n        salesQuantity\n        totalItemsSold\n        averageItemAmount\n        averageItemsPerSale\n        averageSalesAmount\n      }\n      __typename\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4177b8206cb4dd0062914eb6afc85a15";

export default node;
